import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Sparkles, Menu, X } from 'lucide-react';

// Styled Components
const Nav = styled.nav`
  position: fixed;
  width: 100%;
  z-index: 50;
  transition: all 0.3s ease;
  background: ${props => props.$scrolled ? 'white' : 'transparent'};
  box-shadow: ${props => props.$scrolled ? '0 10px 15px -3px rgba(0, 0, 0, 0.1)' : 'none'};
`;

const NavContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }

  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const NavContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  svg {
    width: 32px;
    height: 32px;
    color: ${props => props.$scrolled ? '#9333ea' : 'white'};
    transition: color 0.3s;
  }
`;

const LogoText = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${props => props.$scrolled ? '#040400' : '#000000'};
  transition: color 0.3s;

  @media (max-width: 640px) {
    font-size: 1.125rem;
  }
`;

const DesktopMenu = styled.div`
  display: none;
  gap: 2rem;

  @media (min-width: 768px) {
    display: flex;
  }
`;

const NavLink = styled.a`
  font-weight: 500;
  color: ${props => props.$scrolled ? '#374151' : 'white'};
  transition: color 0.3s;
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    color: ${props => props.$scrolled ? '#eaa733' : '#e9d5ff'};
  }
`;

const MobileMenuButton = styled.button`
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  @media (min-width: 768px) {
    display: none;
  }

  svg {
    color: ${props => props.$scrolled ? '#111827' : 'white'};
    width: 24px;
    height: 24px;
  }
`;

const MobileMenu = styled.div`
  display: ${props => props.$isOpen ? 'block' : 'none'};
  background: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileMenuContent = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const MobileNavLink = styled.a`
  display: block;
  color: #374151;
  font-weight: 500;
  text-decoration: none;
  padding: 0.5rem 0;
  transition: color 0.3s;
  cursor: pointer;

  &:hover {
    color: #9333ea;
  }
`;

// Component
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = ['Trang chủ', 'Dịch vụ', 'Bảng giá', 'Liên hệ'];

  return (
    <Nav $scrolled={scrolled}>
      <NavContainer>
        <NavContent>
          <Logo $scrolled={scrolled}>
            <Sparkles />
            <LogoText $scrolled={scrolled}>KM NAIL HAIR SALON</LogoText>
          </Logo>

          {/* Desktop Menu */}
          <DesktopMenu>
            {menuItems.map((item) => (
              <NavLink
                key={item}
                href={`#${item.toLowerCase()}`}
                $scrolled={scrolled}
              >
                {item}
              </NavLink>
            ))}
          </DesktopMenu>

          {/* Mobile Menu Button */}
          <MobileMenuButton
            $scrolled={scrolled}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X /> : <Menu />}
          </MobileMenuButton>
        </NavContent>
      </NavContainer>

      {/* Mobile Menu */}
      <MobileMenu $isOpen={isMenuOpen}>
        <MobileMenuContent>
          {menuItems.map((item) => (
            <MobileNavLink
              key={item}
              href={`#${item.toLowerCase()}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {item}
            </MobileNavLink>
          ))}
        </MobileMenuContent>
      </MobileMenu>
    </Nav>
  );
};

export default Header;